<template>
  <div class="home-section2">
    <div class="section2-left">
      <div class="left-title">
        <div class="color-line1"></div>
        <div class="color-line2"></div>
        <img src="../../../assets/image/home-student-icon.png" alt="考生服务" />
        <span>考生服务</span>
      </div>
      <div class="left-split"></div>
      <div class="left-split2"></div>
      <div class="left-content">
        <div
          v-for="(item, index) in studentList"
          :key="item.label"
          @click="routerPush(item)"
        >
          <span :class="['imgs', `imgs${index + 1}`]"></span>
          <span>{{ item.label }}</span>
        </div>
      </div>
    </div>
    <div class="section2-center">
      <div class="center-top">
        <div class="top-title">
          <div class="color-line1"></div>
          <div class="color-line2"></div>
          <div>
            <img
              src="../../../assets/image/home-inform-icon1.png"
              alt="通知公告"
            />
            <span>通知公告</span>
          </div>
          <div @click="handleInformMore">
            <span>查看更多</span>
            <img
              src="../../../assets/image/home-inform-icon2.png"
              alt="查看更多"
            />
          </div>
        </div>
        <div class="top-split"></div>
        <div class="top-list">
          <div
            v-for="(item, index) in informList"
            :key="index"
            @click="handleInformItem(item)"
          >
            <div class="points"></div>
            <div>
              <div>{{ item.infoName }}</div>
              <div v-if="item.publishTime">
                {{ item.publishTime.slice(0, 10) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="center-bottom">
        <div class="top-title">
          <div class="color-line1"></div>
          <div class="color-line2"></div>
          <div>
            <img
              src="../../../assets/image/home-industry-icon.png"
              alt="行业动态"
            />
            <span>行业动态</span>
          </div>
          <div @click="handleIndustryMore">
            <span>查看更多</span>
            <img
              src="../../../assets/image/home-inform-icon2.png"
              alt="查看更多"
            />
          </div>
        </div>
        <div class="top-split"></div>
        <div class="top-list">
          <div
            v-for="(item, index) in industryList"
            :key="index"
            @click="handleIndustryItem(item)"
          >
            <div class="points"></div>
            <div>
              <div>{{ item.infoName }}</div>
              <div v-if="item.publishTime">
                {{ item.publishTime.slice(0, 10) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section2-right">
      <div class="right-title">
        <div class="color-line1"></div>
        <div class="color-line2"></div>
        <div>
          <img src="../../../assets/image/home-exam-icon.png" alt="通知公告" />
          <span>考试安排</span>
        </div>
        <div @click="handleExamMore">
          <span>查看更多</span>
          <img
            src="../../../assets/image/home-inform-icon2.png"
            alt="查看更多"
          />
        </div>
      </div>
      <div class="right-split"></div>
      <div class="right-content">
        <div v-for="(item, index) in examList" :key="index">
          <div>{{ item.examTitle }}</div>
          <div v-html="item.examContent"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as API from '../../../api/home/index'
export default {
  name: 'HomeSection2',
  data() {
    return {
      studentList: [
        {
          label: '培训报名',
          // iconPath: require('../../../assets/image/home-student-subicon1.png'),
          routerPath: '/publicTemp',
          routerQuery: {}
        },
        {
          label: '考试报名',
          // iconPath: require('../../../assets/image/home-student-subicon2.png'),
          routerPath: '/publicTemp',
          routerQuery: {}
        },
        {
          label: '证书查询',
          iconPath: require('../../../assets/image/home-student-subicon3.png'),
          routerPath: '/certificate',
          routerQuery: {}
        },
        {
          label: '人才库',
          // iconPath: require('../../../assets/image/home-student-subicon4.png'),
          routerPath: '/publicTemp',
          routerQuery: {}
        },
        {
          label: '机构查询',
          routerPath: '/institutions',
          // iconPath: require('../../../assets/image/home-student-subicon5.png'),
          routerQuery: {}
        }
      ],
      informList: [],
      industryList: [],
      examList: []
    }
  },
  created() {
    this.getInformList()
    this.getIndustryList()
    this.getExamList()
  },
  methods: {
    // 考生服务每项点击路由跳转
    routerPush(row) {
      const { routerPath = '', routerQuery = {} } = row ?? {}
      if (!routerPath) return
      this.$router.push({
        path: routerPath,
        query: routerQuery ?? {}
      })
    },
    // 获取通知公告
    async getInformList() {
      try {
        const params = {
          page: 1,
          limit: 4,
          classifyId: 1
        }
        const res = await API.getListPublic(params)
        const {
          code,
          data: { records = [] }
        } = res
        if (code === 0) {
          this.informList = records
        }
      } catch (error) {}
    },
    // 通知公告查看更多
    handleInformMore() {
      this.$router.push({
        path: '/publicInformationList',
        query: { classifyId: 1 }
      })
    },
    // 通知公告查看单条
    handleInformItem(row) {
      const { id } = row
      this.$router.push({
        path: '/publicInformationDetail',
        query: { classifyId: 1, id }
      })
    },
    // 获取行业动态
    async getIndustryList() {
      try {
        const params = {
          page: 1,
          limit: 4,
          classifyId: 2
        }
        const res = await API.getListPublic(params)
        const {
          code,
          data: { records = [] }
        } = res
        if (code === 0) {
          this.industryList = records
        }
      } catch (error) {}
    },
    // 行业动态查看更多
    handleIndustryMore() {
      this.$router.push({
        path: '/publicInformationList',
        query: { classifyId: 2 }
      })
    },
    handleIndustryItem(row) {
      const { id } = row
      this.$router.push({
        path: '/publicInformationDetail',
        query: { classifyId: 2, id }
      })
    },
    // 获取考试安排
    async getExamList() {
      try {
        const params = { page: 1, limit: 4 }
        const res = await API.getTestList(params)
        const {
          code,
          data: { records = [] }
        } = res
        if (code === 0) {
          this.examList = records
        }
      } catch (error) {}
    },
    // 考试安排查看更多
    handleExamMore() {
      this.$router.push({
        path: '/testPlan'
      })
    }
  }
}
</script>
<style scoped lang="scss">
.home-section2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 48px;

  .section2-left {
    width: 254px;
    height: 479px;
    background: #ffffff;

    .left-title {
      width: 254px;
      height: 66px;
      background: linear-gradient(0deg, #ebebeb 0%, #fdfdfc 100%);
      line-height: 66px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      position: relative;
      display: flex;
      align-items: center;
      > img {
        width: 30px;
        height: 30px;
        margin: 0 10px 0 16px;
      }

      .color-line1 {
        position: absolute;
        width: 236px;
        height: 2px;
        background: #085dc8;
        opacity: 0.35;
        top: 0;
        left: 18px;
      }
      .color-line2 {
        position: absolute;
        width: 128px;
        height: 4px;
        background: #ff4e4e;
        top: 0;
        left: 18px;
      }
    }

    .left-split {
      width: 218px;
      border-bottom: 1px dashed #c6c6c6;
      opacity: 0.7;
      margin: 0 auto;
    }

    .left-content {
      > div {
        width: 100%;
        height: 78px;
        background: #f2f2f2;
        line-height: 78px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        cursor: pointer;
        margin-bottom: 6px;

        .imgs {
          display: inline-block;
          width: 24px;
          height: 24px;
          vertical-align: middle;
          margin: 0 14px 0 79px;
          background-repeat: no-repeat;
          background-position: 0 0;
          background-size: 100% 100%;
        }
        .imgs1 {
          background-image: url(../../../assets/image/home-student-subicon1.png);
        }
        .imgs2 {
          background-image: url(../../../assets/image/home-student-subicon2.png);
        }
        .imgs3 {
          background-image: url(../../../assets/image/home-student-subicon3.png);
        }
        .imgs4 {
          background-image: url(../../../assets/image/home-student-subicon4.png);
        }
        .imgs5 {
          background-image: url(../../../assets/image/home-student-subicon5.png);
        }

        &:hover {
          background: #ff4e4e;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #ffffff;
          .imgs1 {
            background-image: url(../../../assets/image/home-student-subicon1-1.png);
          }
          .imgs2 {
            background-image: url(../../../assets/image/home-student-subicon2-2.png);
          }
          .imgs3 {
            background-image: url(../../../assets/image/home-student-subicon3-3.png);
          }
          .imgs4 {
            background-image: url(../../../assets/image/home-student-subicon4-4.png);
          }
          .imgs5 {
            background-image: url(../../../assets/image/home-student-subicon5-5.png);
          }
        }
      }

      > div:last-child {
        margin-bottom: 0px;
      }
    }
  }

  .section2-center {
    .center-top,
    .center-bottom {
      width: 530px;
      height: 221px;
      background: #ffffff;
      margin-bottom: 37px;

      .top-title {
        width: 530px;
        height: 54px;
        background: linear-gradient(0deg, #ffffff 0%, #eaeaea 100%);
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .color-line1 {
          position: absolute;
          width: 512px;
          height: 2px;
          background: #085dc8;
          opacity: 0.35;
          top: 0;
          left: 18px;
        }
        .color-line2 {
          position: absolute;
          width: 128px;
          height: 4px;
          background: #ff4e4e;
          top: 0;
          left: 18px;
        }

        > div:nth-child(3) {
          display: flex;
          align-items: center;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #333333;

          > img {
            width: 24px;
            height: 24px;
            margin: 0 13px 0 18px;
          }
        }

        > div:last-child {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          cursor: pointer;
          display: flex;
          align-items: center;
          > img {
            width: 18px;
            height: 18px;
            vertical-align: middle;
            margin: 0 15px 0 3px;
          }
        }
      }

      .top-split {
        width: 493px;
        border-bottom: 1px dashed #c6c6c6;
        opacity: 0.7;
        margin: 0 auto;
      }

      .top-list {
        width: 530px;

        // 每行
        > div {
          width: 530px;
          height: 35px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          cursor: pointer;

          .points {
            width: 4px;
            height: 4px;
            background: #ff4e4e;
            border-radius: 50%;
            margin: 0 4px 0 8px;
          }

          // 文字 时间
          > div:last-child {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-right: 18px;
            border-bottom: 1px dashed #c6c6c6;

            // 文字
            > div:first-child {
              width: 344px;
              margin-right: 67px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
            }

            // 时间
            > div:last-child {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #666666;
            }
          }
        }
      }
    }

    .center-bottom {
      margin-bottom: 0;
    }
  }

  .section2-right {
    width: 364px;
    height: 481px;
    background: #ffffff;

    .right-title {
      width: 364px;
      height: 55px;
      background: linear-gradient(0deg, #fcfdfc 0%, #ebebeb 100%);
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .color-line1 {
        position: absolute;
        width: 346px;
        height: 2px;
        background: #085dc8;
        opacity: 0.35;
        top: 0;
        left: 18px;
      }
      .color-line2 {
        position: absolute;
        width: 128px;
        height: 4px;
        background: #ff4e4e;
        top: 0;
        left: 18px;
      }

      > div:nth-child(3) {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;

        > img {
          width: 24px;
          height: 24px;
          margin: 0 13px 0 18px;
        }
      }

      > div:last-child {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        cursor: pointer;

        > img {
          width: 18px;
          height: 18px;
          margin: 0 15px 0 3px;
        }
      }
    }

    .right-split {
      width: 328px;
      border-bottom: 1px dashed #c6c6c6;
      opacity: 0.7;
      margin: 0 auto;
    }

    .right-content {
      > div {
        width: 348px;
        height: 90px;
        background: #f8f8f8;
        margin: 7px auto 14px;
        color: #333333;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        &:hover {
          color: #ffffff;
          background: #085dc8;
        }

        > div:first-child {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          margin-bottom: 19px;
        }

        > div:last-child {
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          width: 100%;
        }
      }

      > div:last-child {
        margin: 0 auto;
      }
    }
  }
}
</style>
